import { render, staticRenderFns } from "./ProfileLayout.vue?vue&type=template&id=15b2eff6&scoped=true"
import script from "./ProfileLayout.vue?vue&type=script&lang=js"
export * from "./ProfileLayout.vue?vue&type=script&lang=js"
import style0 from "./ProfileLayout.vue?vue&type=style&index=0&id=15b2eff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b2eff6",
  null
  
)

export default component.exports